var _rect, _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgePriority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3335_3817)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F26A1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3335_3817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.999,
    cy: 2,
    r: 24,
    fill: "#FFE600"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_3335_3817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -5.50098,
    cy: 65.5,
    r: 40.5,
    fill: "#FF006B"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3335_3817)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4,
    filter: "url(#filter2_f_3335_3817)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0826 11.167C20.9659 11.1669 20.8518 11.2018 20.7552 11.2672C20.6585 11.3326 20.5836 11.4255 20.5403 11.5339L15.8737 23.2005C15.8383 23.2891 15.8252 23.385 15.8354 23.4798C15.8457 23.5746 15.879 23.6654 15.9326 23.7443C15.9861 23.8233 16.0581 23.8879 16.1424 23.9325C16.2267 23.9771 16.3206 24.0004 16.416 24.0003H20.3193L17.0198 36.0977C16.9863 36.2217 16.9947 36.3533 17.0436 36.4721C17.0926 36.5908 17.1794 36.6901 17.2905 36.7545C17.4017 36.819 17.531 36.8449 17.6584 36.8283C17.7858 36.8117 17.9041 36.7535 17.9951 36.6628L33.1617 21.4961C33.2433 21.4145 33.2988 21.3106 33.3213 21.1974C33.3438 21.0843 33.3322 20.967 33.2881 20.8605C33.2439 20.7539 33.1692 20.6628 33.0733 20.5987C32.9774 20.5346 32.8647 20.5004 32.7493 20.5003H28.9257L32.1295 11.9554C32.1627 11.8671 32.1739 11.772 32.1623 11.6784C32.1506 11.5848 32.1165 11.4954 32.0627 11.4179C32.0089 11.3404 31.9372 11.277 31.8536 11.2333C31.7699 11.1896 31.677 11.1669 31.5826 11.167H21.0826Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0826 11.167C20.9659 11.1669 20.8518 11.2018 20.7552 11.2672C20.6585 11.3326 20.5836 11.4255 20.5403 11.5339L15.8737 23.2005C15.8383 23.2891 15.8252 23.385 15.8354 23.4798C15.8457 23.5746 15.879 23.6654 15.9326 23.7443C15.9861 23.8233 16.0581 23.8879 16.1424 23.9325C16.2267 23.9771 16.3206 24.0004 16.416 24.0003H20.3193L17.0198 36.0977C16.9863 36.2217 16.9947 36.3533 17.0436 36.4721C17.0926 36.5908 17.1794 36.6901 17.2905 36.7545C17.4017 36.819 17.531 36.8449 17.6584 36.8283C17.7858 36.8117 17.9041 36.7535 17.9951 36.6628L33.1617 21.4961C33.2433 21.4145 33.2988 21.3106 33.3213 21.1974C33.3438 21.0843 33.3322 20.967 33.2881 20.8605C33.2439 20.7539 33.1692 20.6628 33.0733 20.5987C32.9774 20.5346 32.8647 20.5004 32.7493 20.5003H28.9257L32.1295 11.9554C32.1627 11.8671 32.1739 11.772 32.1623 11.6784C32.1506 11.5848 32.1165 11.4954 32.0627 11.4179C32.0089 11.3404 31.9372 11.277 31.8536 11.2333C31.7699 11.1896 31.677 11.1669 31.5826 11.167H21.0826Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3335_3817",
    x: -20.001,
    y: -62,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_3335_3817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3335_3817",
    x: -106.001,
    y: -35,
    width: 201,
    height: 201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_3335_3817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3335_3817",
    x: 7.83203,
    y: 3.16699,
    width: 33.5,
    height: 41.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3335_3817"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3335_3817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3335_3817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePriority);
export default __webpack_public_path__ + "static/media/badge-priority.1e6622337b094ba642f3e5d339b083de.svg";
export { ForwardRef as ReactComponent };